import { useEffect, useState } from 'react'
import { useSearchParams, Link, useNavigate } from 'react-router-dom'
import { Loader2, CheckCircle, XCircle } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { authAPI } from '@/lib/api-client'
import { useAuthStore } from '@/stores/auth.store'
import { EnlevoLogo } from '@/components/EnlevoLogo'

export function VerifyEmail() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const { setAuth } = useAuthStore()
  const token = searchParams.get('token')

  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading')
  const [errorMessage, setErrorMessage] = useState('')

  useEffect(() => {
    if (!token) {
      setStatus('error')
      setErrorMessage('Token de verificação não encontrado.')
      return
    }

    authAPI.verifyEmail(token)
      .then((response: any) => {
        setStatus('success')
        // Auto-login: save auth data
        setTimeout(() => {
          setAuth(response)
          navigate('/')
        }, 2000)
      })
      .catch((err: Error) => {
        setStatus('error')
        setErrorMessage(err.message || 'Erro ao verificar email.')
      })
  }, [token])

  return (
    <div className="flex min-h-screen items-center justify-center bg-neutral-50 px-6 py-12">
      <div className="w-full max-w-md text-center">
        <div className="mb-6">
          <EnlevoLogo size="md" />
        </div>
        <div className="rounded-lg bg-white p-8 shadow-sm border border-neutral-200">
          {status === 'loading' && (
            <>
              <Loader2 className="mx-auto h-16 w-16 text-primary-600 animate-spin mb-4" />
              <h2 className="text-2xl font-semibold text-neutral-900">Verificando...</h2>
              <p className="mt-3 text-neutral-600">Aguarde enquanto confirmamos seu email.</p>
            </>
          )}

          {status === 'success' && (
            <>
              <CheckCircle className="mx-auto h-16 w-16 text-green-500 mb-4" />
              <h2 className="text-2xl font-semibold text-neutral-900">Email Confirmado!</h2>
              <p className="mt-3 text-neutral-600">
                Sua conta foi ativada com sucesso. Redirecionando...
              </p>
            </>
          )}

          {status === 'error' && (
            <>
              <XCircle className="mx-auto h-16 w-16 text-red-500 mb-4" />
              <h2 className="text-2xl font-semibold text-neutral-900">Falha na Verificação</h2>
              <p className="mt-3 text-neutral-600">{errorMessage}</p>
              <div className="mt-6 space-y-3">
                <Link to="/login">
                  <Button className="w-full">Ir para Login</Button>
                </Link>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  )
}
